import * as React from 'react'
import PhotoUploadIcon from '../icons/ui/PhotoUploadIcon'

//Generate Avatar
import * as Avatar from 'react-avatar'
import ReactAvatar from 'react-avatar'
import Important from '../icons/ui/Important'

interface IProps {
  entityId?: string
  entityId1?: string
  width?: string
  height?: string
  isRounded?: boolean
  name?: string
  name1?: string
  fgcolor: string
}

interface IState {
  onError: boolean
  fgcolor: string
}

class ImageTripCompleted extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      onError: false,
      fgcolor: '#ffffff'
    }
  }

  public render() {
    const { entityId, entityId1, isRounded, fgcolor } = this.props
    const fcolor = this.props.fgcolor || '#ffffff'
    const ee = entityId !== ''

    return (
      <span className='default-p-props'>
        {ee && isRounded && (
          <Avatar.ConfigProvider colors={['#d05030', '#7ed8ec', '#127c94', '#f9d70b', '#83e7b2', '#5b65ab']}>
            <span className='bold-avatar'>
              <ReactAvatar
                style={{ color: 'white' }}
                fgColor={fcolor}
                className='bold-avatar'
                name={this.props.name}
                round={true}
                size='50px'
                textSizeRatio={5.0}
                // color={'#4db87d'}
                src={this.getURL()}
              />
            </span>
          </Avatar.ConfigProvider>
        )}
      </span>
    )
  }

  private onError = () => {
    this.setState({
      onError: true
    })
  }

  private getBucketName = () => {
    return process.env.REACT_APP_ENV === 'production'
      ? process.env.REACT_APP_S3_BUCKET_PROD
      : process.env.REACT_APP_S3_BUCKET_DEV
  }

  private getURL = () => {
    const sha1 = require('sha1')
    const filename = sha1(this.props.entityId)
    return this.state.onError
      ? /* Default Image '/images/goin-placeholder-logo.png' */
        /* New Default Image */
        ''
      : /* New Default Image */
        `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${filename}.png`
  }
}

export default ImageTripCompleted



// WEBPACK FOOTER //
// ./src/components/ui/ImageTripCompleted.tsx